module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.1Rc.1 released")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/cell-box.html"
    }
  }, [_vm._v("CellBox")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] new component")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup-picker.html"
    }
  }, [_vm._v("PopupPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix labelMarginRight #977 @wg5945")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/popup.html"
    }
  }, [_vm._v("Popup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix overflow-scrolling setting in safari #311 @linhaobin")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/radio.html"
    }
  }, [_vm._v("Radio")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] Support icon")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/sticky.html"
    }
  }, [_vm._v("Sticky")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] Fix wrong offset after transition between routes")]), _vm._v(" "), _c('li', [_vm._v("[enhance] Set z-index #976 @olymk")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/en/components/tabbar.html"
    }
  }, [_vm._v("Tabbar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] fix variable @tabbar-text-active-color #982 @marsal1212")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bb72bd8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-6bb72bd8"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.1.1-rc.1-75.vue
// module id = 2312
// module chunks = 360